import type { IDropdownItem } from 'shared/ui'
import { type Inbox } from 'entities/Inbox/model/Inbox.ts'
import { type ISendFromStoreItem } from 'widgets/SendFrom'
import { type IGetDropdownItemsOptions } from 'widgets/SendFrom/lib/getDropdownItems.tsx'
import { getDropdownItems } from './getDropdownItems.tsx'

export const getNotAccessibleInboxDropdownItem = (
  inbox: Inbox,
  options?: IGetDropdownItemsOptions
): IDropdownItem<ISendFromStoreItem> => {
  return getDropdownItems([inbox], {
    getInboxDropdownItemProps: () => {
      return {
        disabled: true,
      }
    },
    hideChildren: true,
    ...options,
  })[0]
}
